<template>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4" style="min-height: 800px; height: auto; overflow:auto">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div class="h4">
                <div>
            <div ref="container">
                <div
                style="opacity: 0;"
                v-show="isFixed"
                class="content"
                :class="{ 'fixed': isFixed }"
                >
                    <nav id="navbar-example2" class="navbar bg-body-tertiary px-3 mb-3">
                        <ul class="nav nav-pills">
                            <li class="nav-item">
                                <a class="nav-link" href="#question">First</a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div
                class="content"
                :class="{ 'fixed': isFixed }"
                ref="fixedDiv"
                >
                    <div style="font-size: 15px; background-color: #ECECEC; width: 1179px; height: 40px; line-height: 20px; padding: 10px;">
                        <span @click="scrollToElement('question')" style="cursor: pointer;" :underline="false">管理题库</span>
                        <span @click="scrollToElement('course')" style="margin-left: 20px; cursor: pointer;" :underline="false">管理课程</span>
                        <span @click="scrollToElement('countCourseSalary')" style="margin-left: 20px; cursor: pointer;" :underline="false">统计课程流水</span>
                        <span @click="scrollToElement('compete')" style="margin-left: 20px; cursor: pointer;" :underline="false">管理竞赛</span>
                        <span @click="scrollToElement('countCompete')" style="margin-left: 20px; cursor: pointer;" :underline="false">统计竞赛</span>
                        <span @click="scrollToElement('countNotes')" style="margin-left: 20px; cursor: pointer;" :underline="false">管理题解</span>
                        <span @click="scrollToElement('countMessage')" style="margin-left: 20px; cursor: pointer;" :underline="false">管理题解</span>
                        <span @click="scrollToElement('countUser')" style="margin-left: 20px; cursor: pointer;" :underline="false">管理用户</span>
                    </div>
                </div>
            </div>
        </div>
            </div>
        </div>

        
        <div id="question"></div>
        <el-divider content-position="center" >管理题库</el-divider>
        <UpdateQuestion></UpdateQuestion>
        <el-divider content-position="center" id="course">管理课程</el-divider>
        <UpdateCourse></UpdateCourse>
        <el-divider content-position="center" id="countCourseSalary">统计课程流水</el-divider>
        <CountCourseSalary></CountCourseSalary>
        <el-divider content-position="center" id="compete">管理竞赛</el-divider>
        <UpdateCompete></UpdateCompete>
        <el-divider content-position="center" id="countCompete">统计竞赛</el-divider>
        <CountCompete></CountCompete>
        <el-divider content-position="center" id="countNotes">管理题解</el-divider>
        <UpdateNotes></UpdateNotes>
        <el-divider content-position="center" id="countMessage">管理帖子</el-divider>
        <UpdateMessage></UpdateMessage>
        <el-divider content-position="center" id="countUser">管理用户</el-divider>
        <UpdateUser></UpdateUser>
    </main>
</template>

<script>
    import UpdateQuestion from './AllQuestion/UpdateQuestion.vue'
    import UpdateCourse from './Course/UpdateCourse.vue'
    import UpdateCompete from './Compete/UpdateCompete.vue'
    import CountCompete from './Compete/CountCompete.vue'
    import UpdateNotes from './Notes/UpdateNotes.vue'
    import UpdateMessage from './Message/UpdateMessage.vue'
    import UpdateUser from './User/UpdateUser.vue'
    import CountCourseSalary from './Course/CountCourseSalary.vue'
    export default {
        name:'Manage',
        components: {   
            UpdateQuestion,
            UpdateCourse,
            UpdateCompete,
            CountCompete,
            UpdateNotes,
            UpdateMessage,
            UpdateUser,
            CountCourseSalary,
        },
        data() {
            return {
                isFixed: false,
                originalTop: null,
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            this.originalTop = this.$refs.fixedDiv.getBoundingClientRect().top;
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollToElement(id) {
                const targetElement = document.getElementById(id);
                if (targetElement) {
                    const offset = 120; // 调整的偏移量
                    const targetPosition = targetElement.offsetTop - offset;

                    window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth' // 平滑滚动
                    });
                }
            },
            handleScroll() {
            const fixedDiv = this.$refs.fixedDiv;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const currentTop = fixedDiv.getBoundingClientRect().top;

            // 获取滚动超过一定位置时固定
            const offset = 60;

            if (scrollTop > offset && currentTop <= offset) {
                fixedDiv.style.position = 'fixed';
                fixedDiv.style.top = `${offset}px`;
                fixedDiv.style.width = `${fixedDiv.offsetWidth}px`;
                this.isFixed = true;
            } else {
                fixedDiv.style.position = 'static';
                fixedDiv.style.width = 'auto';
                this.isFixed = false;
            }
            },
        },
    }
</script>

<style scoped>
.container {
  position: relative;
}

.content {
  /* 添加样式以控制外观和布局 */
  width: 100%;
  z-index: 1000;
}
</style>